import axios from "axios"; 
import { layer } from "@layui/layui-vue";
import { getToken,removeToken } from '@/utils/auth'
import router from '../router'

const service = axios.create({
    baseURL: 'https://api.jdhwe.xyz', //http://127.0.0.1:8078      //https://api.jdhwe.xyz
    timeout: 30000,// request timeout
    // withCredentials:true
})
// 请求拦截
service.interceptors.request.use( 
    (config: any) => { 
        config.headers['token'] = getToken()

        return config
    },
    (error: any) => {
        console.log(111);
        return Promise.reject(error)
    }
)
 
// 响应拦截
service.interceptors.response.use(
    (response: any) => {
        const res = response.data
    
        
        if (res.code==0) {
            return response.data
        } else if(res.code==1008){
            layer.msg(res.msg, { icon : 2, time: 1000}) 
            removeToken();
            router.push({ path: '/login' }) 
            return "";
        }else {
            layer.msg(res.msg, { icon : 2, time: 1000}) 
            return "";
        }
    },
    (error: any) => {
        console.log(22222222222);
        if (error.response) {
            switch (error.response.status) {
                case 500:
                    layer.msg("服务器错误，请稍后重试", { icon : 2, time: 1000}) 
                    return "";
                    
                default:
                    layer.msg("服务器错误，请稍后重试", { icon : 2, time: 1000})  
                    return "";
            }
        }
    }
)
 
export default service